module.exports = __webpack_public_path__ + "static/img/mq_blue_logo.f828049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mq_blue_logo.png
// module id = ymwB
// module chunks = 3